import { GlobalStore } from "../../../store/global/GlobalStore";
import { MOBILE_WIDTH, useIsMobile } from "../../../hooks/useDeviceType";
import { useWindowSize } from "usehooks-ts";
import { useMemo } from "react";
import { getCardWidth } from "./element/Carousel/Card";
import { Carousel, CAROUSEL_FLEX_CONTAINER_GAP } from "./element/Carousel/Carousel";
import { HomepageCard } from "./element/Carousel/HomepageCard";
import { Text } from "../../../components/general/Text";
import codeSnippetImgSrc from "../../../img/home/code-snippet.png";
import { Spacer } from "../../../components/general/Spacer/Spacer";
import fishesImgSrc from "../../../img/home/fishes.png";
import moustacheManImgSrc from "../../../img/home/moustache-man.png";
import mountainImgSrc from "../../../img/home/mountain.png";
import islandImgSrc from "../../../img/home/island.png";
import { NonCarouselContainer } from "./FeatureCards";
import { css } from "@emotion/react";
import { Theme } from "../../../styles/theme";
import TickIcon from "../../../img/tick.svg?react";
export const FeatureCardsTwo = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const isMobile = useIsMobile();
  const cardContents = getCardContents(theme, isMobile);
  const { width: windowWidth } = useWindowSize();
  const shouldUseCarousel = useMemo(() => {
    const cardCount = cardContents.length;
    const cardWidth = getCardWidth(isMobile);
    return cardWidth * cardCount + CAROUSEL_FLEX_CONTAINER_GAP * (cardCount - 1) >= windowWidth;
  }, [cardContents.length, isMobile, windowWidth]);
  const Wrapper = shouldUseCarousel ? Carousel : NonCarouselContainer;

  return (
    <Wrapper style={{ marginTop: 48, color: theme.button.secondary.text.default, zIndex: 1 }}>
      {cardContents.map(entry => (
        <HomepageCard key={entry.title} title={entry.title} body={entry.body} color={entry.color}>
          {entry.children}
        </HomepageCard>
      ))}
    </Wrapper>
  );
};

// Helpers

const cardTextCss = css`
  margin-bottom: 6px;
  @media (max-width: ${MOBILE_WIDTH}px) {
    font-size: 14px;
  }
`;

const LIST_CONTENT_CARD_2 = [
  "Market leading success rates",
  "Lightning speed",
  "Generous rate limits",
  "Secure and audited smart contracts",
];

const getCardContents = (theme: Theme, isMobile: boolean) => [
  {
    title: "Trading and data APIs",
    color: theme["Brand colours"].Aqua,
    children: (
      <>
        <Text textStyle="Paragraph" size="XXL" color="" textCss={cardTextCss} shouldScale={true}>
          Access pricing and trade execution across the most efficient paths, for any number of
          tokens at once.
        </Text>
        <Text textStyle="Paragraph" size="XXL" shouldScale={true} textCss={cardTextCss}>
          Get enhanced token metadata and rich content set for trade history.
        </Text>
        <img
          src={codeSnippetImgSrc}
          alt="Code snippet"
          width={isMobile ? 200 : 300}
          style={{ position: "absolute", bottom: 0, right: 0 }}
        />
      </>
    ),
  },
  {
    title: "Fit for degens and enterprises",
    body: "Take advantage of integration with us for any use case.",
    color: theme["Brand colours"].Green,
    children: (
      <>
        <div style={{ marginTop: 8 }}>
          {LIST_CONTENT_CARD_2.map(content => (
            <div key={content} style={{ display: "flex" }}>
              <TickIcon
                strokeWidth={1.5}
                style={{
                  width: isMobile ? 20 : 24,
                  minWidth: isMobile ? 20 : 24,
                  height: isMobile ? 20 : 24,
                  minHeight: isMobile ? 20 : 24,
                }}
              />
              <Spacer minWidth={isMobile ? 4 : 9} />
              <Text textStyle="Paragraph" size="XXL" textCss={cardTextCss} shouldScale={true}>
                {content}
              </Text>
            </div>
          ))}
        </div>
        <img
          src={fishesImgSrc}
          alt="Fishes"
          width={isMobile ? 190 : 273}
          style={{ position: "absolute", bottom: 24, right: 20 }}
        />
      </>
    ),
  },
  {
    title: "Expert support",
    body: "Access our comprehensive documentation and explore your ideas inside the API playground. Stay in touch with our developers who provide technical assistance via our open and dedicated private channels.",
    color: theme["Brand colours"].Red,
    children: (
      <img
        src={moustacheManImgSrc}
        alt="Man with a moustache"
        width={isMobile ? 180 : 285}
        style={{ position: "absolute", bottom: 0, right: 0 }}
      />
    ),
  },
  {
    title: "A revenue stream for your app",
    body: "Monetise your application through trade execution.",
    color: theme["Brand colours"]["Baby Blue"],
    children: (
      <img
        src={mountainImgSrc}
        alt="Man with a moustache"
        width={isMobile ? 240 : 360}
        style={{ position: "absolute", bottom: 0, right: 0 }}
      />
    ),
  },
  {
    title: "Interoperability",
    body: "Get creative and supercharge your product by connecting to Bebop trade execution with our hooks.",
    color: theme["Brand colours"].Pink,
    children: (
      <img
        src={islandImgSrc}
        alt="Man with a moustache"
        width={isMobile ? 200 : 300}
        style={{ position: "absolute", bottom: 20, right: 0 }}
      />
    ),
  },
];
